const useRole = () => useSelector((state) => { var _a; return (_a = state.auth) === null || _a === void 0 ? void 0 : _a.role.code; });
export default useRole;
